import { render, staticRenderFns } from "./member_form.vue?vue&type=template&id=5387bdb9"
import script from "./member_form.vue?vue&type=script&lang=ts"
export * from "./member_form.vue?vue&type=script&lang=ts"
import style0 from "./member_form.vue?vue&type=style&index=0&id=5387bdb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports